import { render, staticRenderFns } from "./simpleProduct.vue?vue&type=template&id=fe6f8e26&scoped=true&"
import script from "./simpleProduct.vue?vue&type=script&lang=js&"
export * from "./simpleProduct.vue?vue&type=script&lang=js&"
import style0 from "./simpleProduct.vue?vue&type=style&index=0&id=fe6f8e26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6f8e26",
  null
  
)

export default component.exports